import TitleWrapper from "./TitleWrapper";

export default TitleWrapper;
